import "@testing-library/jest-dom";
import React from "react";
import { render, screen } from "@testing-library/react";
import { MemoryRouter } from "react-router-dom";
import { CanvasDataWidgetRenderer } from "./CanvasDataWidgetRenderer";
const mockPages = [
  Array.from({ length: 100 }, (_, id) => ({
    id,
    _rowId: String(id),
    name: `Person ${id}`,
    manager: id ? 0 : null,
  })),
  Array.from({ length: 15 }, (_, index) => ({
    id: index + 100,
    _rowId: String(index + 100),
    name: `Person ${index + 100}`,
    manager: 0,
  })),
];
const mockQueries = jest.fn();
jest.mock("../../../hooks/useViewDataQuery", () => ({
  useViewDataQuery: (viewId: string, params: { page: number }) => {
    mockQueries(viewId, params);
    return {
      data: { rows: mockPages[params.page - 1], totalCount: 115 },
      isLoading: false,
      error: null,
      refetch: jest.fn(),
    };
  },
}));
jest.mock("../../../../../providers/WorkspaceProvider", () => ({
  useWorkspaceContext: () => ({ workspace: { id: "ws" } }),
}));
jest.mock("../CanvasRuntimeContext", () => ({
  useCanvasRuntime: () => ({
    workspaceId: "ws",
    canvasId: "canvas",
    interactionBus: { getRuntimeFilters: () => [] },
  }),
}));
jest.mock("../../../../../utils/useAuthFetch", () => ({
  useAuthFetch: () => jest.fn(),
}));
test("shared hierarchy uses the real accumulated hook to render all 115 rows from pages 100/15", async () => {
  const element = {
    id: "graph",
    type: "hierarchy",
    props: {
      hierarchy_config: {
        nodes: [
          {
            data_source_alias: "people",
            table_id: "table",
            id_field: "id",
            label_field: "name",
          },
        ],
        relationships: [
          {
            relationship_ids: ["manager"],
            from_data_source_alias: "people",
            to_data_source_alias: "people",
            from_field: "manager",
            to_field: "id",
            reverse: true,
          },
        ],
        layout: "list",
      },
    },
  } as any;
  render(
    <MemoryRouter>
      <CanvasDataWidgetRenderer
        element={element}
        dataSources={
          [{ id: "people", name: "People", view_id: "people-view" }] as any
        }
        canvasId="canvas"
      />
    </MemoryRouter>,
  );
  expect(await screen.findByText("Person 114")).toBeVisible();
  expect(screen.getAllByRole("group", { name: /^Item Person/ })).toHaveLength(
    115,
  );
  expect(mockQueries).toHaveBeenCalledWith(
    "people-view",
    expect.objectContaining({ page: 2, pageSize: 100, canvasId: "canvas" }),
  );
  expect(screen.queryByText(/Partial hierarchy/)).not.toBeInTheDocument();
});
